<div class="general-error-container">
  <img src="assets/icon/icon_error.svg" />
  <div>
    {{ text }}
  </div>
</div>
